<template>
  <div class="app-file" :class="{ 'has-error': error && error.length }">
    <label v-if="label" :id="label">{{ label }}</label>

    <div
      class="app-file-wrap"
      :class="{ 'has-start-icon': startIcon, disabled: disabled || loading }"
      @click="openFile"
    >
      <div class="start-icon" v-if="startIcon" v-html="$icon(startIcon)"></div>

      <input
        type="file"
        ref="file"
        :id="label || id"
        :disabled="disabled || loading"
        :accept="accept || undefined"
        @change="onChange"
      />

      <div class="app-file-name">{{ imageName ? imageName : placeholder }}</div>

      <div
        class="app-file-remove"
        @click.stop="removeFile"
        v-if="imageName"
        v-html="$icon('cancel')"
      ></div>

      <div class="icon" v-if="icon" v-html="$icon(icon)"></div>
      <div class="loader" v-if="loading" v-html="$icon('loader')"></div>
    </div>

    <p class="message" v-if="message">{{ message }}</p>
    <p class="error" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import { nextTick } from "vue";

export default {
  name: "app-file",

  emits: ["update:modelValue", "update:imageName", "focus", "blur", "change"],

  props: {
    modelValue: [File, Blob, String],
    imageName: [String, Boolean],
    icon: [String, Boolean],
    startIcon: [String, Boolean],
    label: String,
    id: String,
    value: [String],
    placeholder: String,
    message: String,
    error: String,
    accept: String,
    loading: false,
    disabled: false,
    returnBase: false,
  },

  data() {
    return {
      newValue: this.modelValue,
      fileSelected: null,
    };
  },

  mounted() {},

  watch: {
    modelValue() {
      this.newValue = this.modelValue;

      if (!this.newValue) {
        this.removeFile();
      }
    },
  },

  methods: {
    updateFileName(name) {
      this.$emit("update:imageName", name);
    },
    openFile() {
      this.$refs.file.click();
    },
    removeFile() {
      this.fileSelected = null;
      this.updateFileName(null);
      this.$refs.file.value = "";
      this.$emit("update:modelValue", null);
      this.$emit("change", null);
    },
    onChange(e) {
      let file = e.target.files[0];

      // console.log('test')

      this.fileSelected = file;

      this.updateFileName(this.fileSelected.name);

      if (!file) {
        this.removeFile();
        return;
      }

      if (this.returnBase) {
        const reader = new FileReader();

        reader.onload = (e) => {
          file = e.target.result;

          this.$emit("update:modelValue", file);
          this.$emit("change", file);
        };

        reader.readAsDataURL(file);
        return;
      }

      this.$emit("update:modelValue", file);
      this.$emit("change", file);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-file {
  .loader {
    ::v-deep svg {
      stroke: black;
    }
  }
}

.en-class .app-file .start-icon {
  left: 10px;
}
.he-class .app-file .start-icon {
  right: 10px;
}
</style>
